import { BaseSerializer } from '../base.serializer'
import { ExamSection } from 'models/exams'
import { SectionGradeSerializer } from './section-grade.serializer';


export class ExamSectionSerializer extends BaseSerializer<ExamSection> {
  static SERIALIZABLE_ATTRIBUTES = [
    'id',
    'examId',
    'sectionId',
    'factor',
    'shuffleQuestions',
    'questionsCount',
    'amountForShow',
    'questionIds',
    '_destroy',
    'blocking',
    'grades'
  ]
  static SERIALIZERS = {
    grades: SectionGradeSerializer
  }

  static SERIALIZE_RENAME_KEYS = {
    sectionId: 'examsSectionId',
    grades: 'gradesAttributes'
  }

  static DESERIALIZERS = {
    examsSectionId: 'sectionId',
    grades: SectionGradeSerializer
  }
  
  static DESERIALIZE_RENAME_KEYS = {}

  static initializeObject(attributes: Object): ExamSection {
    return new ExamSection(attributes)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/exams/exam-section.serializer.ts